import FormSelect from './FormSelect'
import { mapGetters } from 'vuex'
import {
  getCourseComponents
} from '@/api'
export default {
  name: 'FormComponentSelect',
  extends: FormSelect,
  props: {
    formValue: {
      type: Object,
      default: () => ({}),
    },
    questionId: {
      type: String,
      default: '',
    },
    /*
    The FormComponentSelect input can be used in one of two ways
    1. To select from a list of copmponents already assigned to a course
    2. To select from all components that are available as options, regardless or not if they are associated with the course
    For option 2, we must load all components in from the BE
    */
    loadOptions: {
      type: Boolean,
      default: false,
    },
    emptyWhenNoSource: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      isOpen: false,
      isLoading: false,
      options: [],
      optionsLoaded: false,
    }
  },
  computed: {
    ...mapGetters([ 'school' ]),
    mergedConfig () {
      return {
        multiple: false,
        searchable: true,
        options: [],
        ...this.config,
      }
    },
    normalizedOptions () {
      // ensuring options are unique and sorting the resulting array
      return [ ...new Set(this.allOptionNames) ].sort()
    },
    components () {
      return this.formValue?.components || []
    },
    allowOptional () {
      return ![ 'primaryComponent', 'gradedComponent' ].includes(this.questionId)
    },
    allOptionNames () {
      const optionalComponentsFilter = component => this.allowOptional || !component.optionalComponent
      const componentNameMapper = el => el.name

      return this.components
        .concat(this.options, this.mergedConfig.options || [])
        .filter(optionalComponentsFilter)
        .map(componentNameMapper)
        .filter(Boolean)
    },
  },
  watch: {
    isOpen: {
      async handler (val) {
        if (val && !this.optionsLoaded && this.loadOptions) {
          this.isLoading = true
          const params = {
            school: this.school,
            returnFields: '_id,code,name',
          }
          const data = await getCourseComponents(params) || {}
          this.options = Object.values(data)
          this.$emit('optionsLoaded', this.options)
          this.optionsLoaded = true
          this.isLoading = false
        }
      },
    },
  },
}
